export default __webpack_public_path__ + "static/media/testimony_student_one.767f16d4.png";